import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ProductCarousel = () => {
  const { t } = useTranslation();
  const [selectedProduct, setSelectedProduct] = useState(null);

const products = [
  { 
    id: 3, 
    name: t('product_name_3'),
    image: "images/p3.webp", 
    description: t('product_desc_3'), 
  },
  { 
    id: 2, 
    name: t('product_name_2'), 
    image: "images/p2.webp", 
    description: t('product_desc_2'), 
  },
  { 
    id: 1, 
    name: t('product_name_1'), 
    image: "images/p1.webp", 
    description: t('product_desc_1'), 
  },
  { 
    id: 5, 
    name: t('product_name_5'), 
    image: "images/p5.webp", 
    description: t('product_desc_5'), 
  },
  { 
    id: 6, 
    name: t('product_name_6'), 
    image: "images/p6.webp", 
    description: t('product_desc_6'), 
  },
  { 
    id: 7, 
    name: t('product_name_7'), 
    image: "images/p7.webp", 
    description: t('product_desc_7'), 
  },
  { 
    id: 8, 
    name: t('product_name_8'), 
    image: "images/p8.webp", 
    description: t('product_desc_8'), 
  },
  { 
    id: 9, 
    name: t('product_name_9'), 
    image: "images/p9.webp", 
    description: t('product_desc_9'), 
  }
];

  const ProductDialog = ({ product, onClose }) => (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <button className="close-button" onClick={onClose}>×</button>
        <img src={product.image} alt={product.name} />
        <h2>{product.name}</h2>
        <p>{product.description}</p>
        <h3>{product.price}</h3>
      </div>
    </div>
  );

  return (
    <div className="carousel-wrapper">
      <div className="heading_container heading_center">
        <h1 className='fw-bold mb-5 text-secondary'>{t('best-seller')}</h1>
      </div>

      <div className="product-container">
        {products.map(product => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />

            <div className="product-details">
              <h5>{product.name}</h5>
              <p className="price">{product.price}</p>

              <button className="view-more-btn" onClick={() => setSelectedProduct(product)}>
                {t('view-more')}
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedProduct && (
        <ProductDialog 
          product={selectedProduct} 
          onClose={() => setSelectedProduct(null)} 
        />
      )}
    </div>
  );
};

export default ProductCarousel;
